import Pagination from "react-js-pagination";
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { open } from "../redux/popupSlice";
import routes from '../libs/routes';
import moment from "moment";
import PopupLicensing from "../pages/popup/PopupLicensing";
import PopupSubinfo from "../pages/popup/PopupSubinfo";

export default function PaginationLicense(props) {
    const {
        coupon, // 이미 필터링된 리스트
        view,
        search,
        dropLicense,
        dropGroup,
        dropNumber,
        payList,
        subscribelist,
        payinfolists
    } = props;

    const dispatch = useDispatch();
    const dataList = coupon; // 부모에서 전달된 데이터는 이미 필터링되어 있음
    const lang = useSelector(state => state.langReducer.lang);
    const [page, setPage] = useState(1);

    const handlePageChange = (pageNumber) => {
        setPage(pageNumber);
    };

    const itemsPerPage = 8;
    const indexOfLastItem = page * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const filteredDataList = dataList; // 중복 필터링 제거
    const Items = filteredDataList.slice(indexOfFirstItem, indexOfLastItem);

    const { mbData } = useSelector(s => s.usersReducer);

    const checkMember = (data, id) => {
        for (const record of data) {
            const licenseGroup = record.licenseGroup;
            if (licenseGroup) {
                if (
                    licenseGroup.groupOwner &&
                    licenseGroup.groupOwner.some((owner) => owner.id === id)
                ) {
                    return "groupOwner";
                }
                if (
                    licenseGroup.groupManager &&
                    licenseGroup.groupManager.some((manager) => manager.id === id)
                ) {
                    return "groupManager";
                }
            }
        }
        return "none";
    };

    const pro = useSelector((s) => s.licenseReducer.pro);
    const art = useSelector((s) => s.licenseReducer.art);
    const all = useSelector((s) => s.licenseReducer.all);

    const check = checkMember([...pro, ...art, ...all], mbData.idx);
    const isOwner = check === "groupOwner";
    const isManager = check === "groupManager";

    const LicensingPopPer = (type, user, license) => {
        dispatch(open({
            component:
                <PopupLicensing
                    popType={"per"}
                    perType={type}
                    button={lang === 0 ? '저장' : 'Save'}
                    buttonCancel={lang === 0 ? '취소' : 'Cancel'}
                    user={user}
                    license={license}
                />
        }));
    };

    const LicensingPopState = (type, license) => {
        dispatch(open({
            component:
                <PopupLicensing
                    popType={"state"}
                    stateType={type}
                    button={lang === 0 ? '저장' : 'Save'}
                    buttonCancel={lang === 0 ? '취소' : 'Cancel'}
                    modelType={'Pro'}
                    view={view}
                    license={license}
                />
        }));
    };

    const LicensingPopStateout = () => {
        dispatch(open({
            component:
                <PopupLicensing
                    max_width={'600px'}
                    popType={"state"}
                    stateType={lang === 0 ? '할당' : 'Assign'}
                />
        }));
    };

    const LicensingSubinfo = (license) => {
        let subscribeCker = subscribelist?.filter(item => item?.licenseCode === license?.licenseCode);
        console.log(payList, subscribelist, subscribeCker);

        let SubinfoTypes = -1;
        let SubinfoTest = -1;
        if(subscribeCker?.length > 0){
            if(subscribeCker[0]?.ingstate*1 === 3){
                SubinfoTypes = 2;
                SubinfoTest = -1;
            } else if(subscribeCker[0]?.ingstate*1 === 4){
                SubinfoTypes = 4;
                SubinfoTest = -1;
            } else if(subscribeCker[0]?.ingstate*1 === 5){
                SubinfoTypes = 1;
                SubinfoTest = 1;
            } else {
                SubinfoTypes = 0;
                SubinfoTest = -1;
            }
        }
        if(license?.licenseGroup?.groupId === ''){
            if(moment(license?.licenseGroup?.expiredAt) < moment()){
                SubinfoTypes = 4;
                SubinfoTest = -1;
            } else {
                SubinfoTypes = 1;
                SubinfoTest = 1;

            }
        }
        dispatch(open({
            component:
                <PopupSubinfo
                    max_width={'500px'}
                    license={license}
                    SubinfoType={SubinfoTypes}
                    payList={payList}
                    subscribelist={subscribeCker}
                    SubinfoTest={SubinfoTest}
                    payinfolists={payinfolists}
                />
        }));
    };

    const getStatus = (x) => {
        if (!x) return { status: '', preStatus: false };
        const today = new Date();
        const expired = new Date(x.revokedAt || x.licenseGroup.expiredAt);
        let status;
        let preStatus = false;
        
        if (expired < today) {
          status = lang === 0 ? '만료' : 'Expired';
        } else {
          status = lang === 0 ? '활성' : 'Active';
        }
    
        return { status, preStatus };
    };

    const getLine = (x) => {
        //const subscriptionType = x.licenseCode === '' ? (lang === 0 ? '무료 체험' : 'Trial') : (lang === 0 ? '유료' : 'Paid');
        const subscriptionType = '';
        const owner = x.licenseGroup?.groupOwner;
        const managers = x.licenseGroup?.groupManager;
        const licenseUser = x.user;

        let subscribe = subscribelist?.find(item => item?.licenseCode === x?.licenseCode );
        let role = '';
        if (licenseUser) {
            if (owner?.some(m => m.id === licenseUser.id)) {
                role = 'Owner';
            } else if (managers?.some(m => m.id === licenseUser.id)) {
                role = 'Manager';
            } else {
                role = 'User';
            }
        }

        const { status, preStatus } = getStatus(x);
        const isTrial = x.licenseGroup.licenseCategory === 4;

        console.log(x);
        return (
            <div key={x.id} className={`my_coupon_info`}>
                <p className="top120">
                    {x?.licenseCode}
                </p>
                <p className="info top220">
                    {subscriptionType}
                    <button
                        type="button"
                        onClick={() => {
                            LicensingSubinfo(x);
                        }}
                    >
                        {lang === 0 ? '상세정보' : 'Detail'}
                    </button>
                </p>
                {/* <p className="top64">{x.user?.team?.name}</p> */}
                {/* <p className="top64">{x.user?.fullname}</p>
                <p className="top220">{x.user?.email}</p> */}
                {/* {x?.licenseCode?.includes('PRO') ?
                <p className="top64 per"></p>
                :
                <p
                    className="top64 per"
                    onClick={() => {
                        if (isOwner) {
                            LicensingPopPer(role, x.user, x);
                        }
                    }}
                >
                    {role}
                </p>} */}
                <p className="top220">{moment(x?.licenseGroup?.createdAt).format('YYYY-MM-DD HH:mm')}</p>
                <p className="top220">
                    {subscribe ?
                    <>
                        {(subscribe?.ingstate*1 === 1 || subscribe?.ingstate*1 === 2) ?
                        <>{moment(subscribe?.endDate).format('YYYY-MM-DD HH:mm')}</>
                        :
                        '-'
                        }
                    </>
                    :
                    '-'
                    }
                </p>

                {x?.licenseCode?.includes('PRO') ?
                <p className={`${isTrial ? '' : 'state'} top140 ${status === (lang === 0 ? '만료' : 'Expired') ? 'out' : ''} ${status === '할당' ? 'off' : ''}`}>
                    {status === (lang === 0 ? '활성' : 'Active') &&
                        <>
                            <img src={require("../assets/icon/solid_check.svg").default} style={{ marginRight: '4px' }} />
                            {lang === 0 ? '활성' : 'Active'}
                        </>
                    }
                    {status === (lang === 0 ? '만료' : 'Expired') && (
                        <>
                            {lang === 0 ? '만료' : 'Expired'}
                            {!isTrial && (
                                <>
                                    <br />
                                    <span>({lang === 0 ? 'Owner에게 문의하세요' : 'Contact Owner'})</span>
                                </>
                            )}
                        </>
                    )}
                    {status === (lang === 0 ? '비활성' : 'Inactive') &&
                        <>
                            <img src={require("../assets/icon/add-line-blue.svg").default} />
                            {lang === 0 ? '라이선스 할당' : 'Assign License'}
                        </>
                    }                    
                </p>
                :
                <p
                    className={`${isTrial ? '' : 'state'} top140 ${status === (lang === 0 ? '만료' : 'Expired') ? 'out' : ''} ${status === '할당' ? 'off' : ''}`}
                    onClick={isTrial ? null : () => {
                        
                        if (status === '할당') {
                            LicensingPopStateout();
                        }
                        if (status === (lang === 0 ? '활성' : 'Active')) {
                            LicensingPopState(status, x);
                        }
                        if (status === (lang === 0 ? '비활성' : 'Inactive')) {
                            LicensingPopState(status, x);
                        }
                    }}
                >
                    {status === (lang === 0 ? '활성' : 'Active') &&
                        <>
                            <img src={require("../assets/icon/solid_check.svg").default} style={{ marginRight: '4px' }} />
                            {lang === 0 ? '활성' : 'Active'}
                        </>
                    }
                    {status === (lang === 0 ? '만료' : 'Expired') && (
                        <>
                            {lang === 0 ? '만료' : 'Expired'}
                            {!isTrial && (
                                <>
                                    <br />
                                    <span>({lang === 0 ? 'Owner에게 문의하세요' : 'Contact Owner'})</span>
                                </>
                            )}
                        </>
                    )}
                    {status === (lang === 0 ? '비활성' : 'Inactive') &&
                        <>
                            <img src={require("../assets/icon/add-line-blue.svg").default} />
                            {lang === 0 ? '라이선스 할당' : 'Assign License'}
                        </>
                    }
                </p>}
            </div>
        )
    };

    return (
        <div className="PaginationContent">
            <div className="my_coupon_list_box page_pro">
                <div className="list_title">
                    <p className="top120">{lang === 0 ? '라이선스 no' : 'License No.'}</p>
                    <p className="top220">{lang === 0 ? '청구옵션' : 'Billing Option'}</p>
                    {/* <p className="top64">{lang === 0 ? '조직' : 'Organization'}</p> */}
                    {/* <p className="top64">{lang === 0 ? '이름' : 'Name'}</p>
                    <p className="top220">{lang === 0 ? '계정' : 'Account'}</p> */}
                    {/* <p className="top64">{lang === 0 ? '권한' : 'Role'}</p> */}
                    <p className="top220">{lang === 0 ? '시작일' : 'Start Date'}</p>
                    <p className="top220">{lang === 0 ? '다음결제일' : 'Next Billing Date'}</p>
                    <p className="top140">{lang === 0 ? '라이선스 상태' : 'License Status'}</p>
                </div>

                {dataList && dataList.length > 0 ?
                    <>
                        {Items.map(x => (
                            getLine(x)
                        ))}
                    </>
                    :
                    <p className="not_coupon">{lang === 0 ? '결제 내역이 없습니다.' : 'No payment history.'}</p>
                }
            </div>

            <Pagination
                className="my-pagination"
                activePage={page}
                itemsCountPerPage={8}
                totalItemsCount={dataList.length || 1}
                pageRangeDisplayed={10}
                onChange={handlePageChange}
                nextPageText={<img src={require("../assets/icon/page_right.svg").default} />}
                prevPageText={<img src={require("../assets/icon/page_left.svg").default} />}
                firstPageText={<img src={require("../assets/icon/page_left_set.svg").default} />}
                lastPageText={<img src={require("../assets/icon/page_right_set.svg").default} />}
            ></Pagination>
        </div>
    );
}